import { startAppEntry } from '@frontend/you-shared-utils/app-entry';

startAppEntry({
  load: () => import('./bootstrap'),
  appScope: 'PAYMENT',
});
